import { Box } from '@chakra-ui/react';
import parse, { domToReact } from 'html-react-parser';
import { AppLink } from 'components/Link/AppLink';

const options = {
  replace: (domNode: any) => {
    if (domNode.type === 'tag') {
      if (domNode.name === 'a') {
        return (
          <AppLink
            href={domNode?.attribs?.href}
            target="_blank"
            rel="noreferrer"
          >
            {domToReact(domNode?.children || [])}
          </AppLink>
        );
      }
    }
  },
};

const baseCss = {
  '& h1': {
    fontSize: ['xl', '2xl'],
    fontWeight: 'bold',
    mb: 4,
  },
  '& h2': {
    fontSize: ['lg', 'xl'],
    fontWeight: 'bold',
    mb: 3,
  },
  '& p': {
    mb: 2,
    lineHeight: 'tall',
  },
  '& ul, ol': {
    ml: 6,
    mb: 4,
  },
  '& li': {
    mb: 2,
  },
  '& b, strong': {
    fontWeight: '700',
  },
  '& em': {
    fontStyle: 'italic',
  },
};

const parseInstructionsHtml = (html: string) => parse(html, options);

export const IsolatedContent = ({ html }: { html: string }) => {
  return (
    <Box
      data-testid="isolated-instructions-content"
      w="full"
      flexShrink={0}
      title="Instructions Content"
      css={baseCss}
    >
      {parseInstructionsHtml(html)}
    </Box>
  );
};
